<app-str-spinner [message]="spinnerMessage"></app-str-spinner>

<div class="tds-u-m2">
    <tds-table vertical-dividers="false" compact-design="false" responsive>
        <tds-table-toolbar table-title="Filter" filter ></tds-table-toolbar>
        <tds-table-header >
        <tds-header-cell cell-value="Name"></tds-header-cell>
        <tds-header-cell cell-value="Email"></tds-header-cell>
        <tds-header-cell cell-value="System Admin" ></tds-header-cell>
        <tds-header-cell cell-value="Reporting Admin"></tds-header-cell>
        </tds-table-header>
        <tds-table-body>
        <tds-table-body-row *ngFor="let employee of slicedRows">
            <tds-body-cell>
                <div>
                    {{employee.empName}}
                </div>
            </tds-body-cell>
            <tds-body-cell>
                <div>
                    {{employee.email}}
                </div>
            </tds-body-cell>
            <tds-body-cell *ngIf="loggedAccount?.changeAdminAuthority">
                <div *ngIf="employee.isSysAdmin" (change)="changeAdminStatus(employee)">
                    <tds-toggle checked size="lg" >
                        <div slot="label">Yes</div>
                    </tds-toggle>
                </div>
                <div  *ngIf="!employee.isSysAdmin" (change)="changeAdminStatus(employee)">
                    <tds-toggle size="lg">
                        <div slot="label">No</div>
                    </tds-toggle>
                </div>
            </tds-body-cell>
            <tds-body-cell>
                <div *ngIf="employee.isReporting">
                    <tds-toggle checked size="lg"  (change)="changeReportingStatus(employee)">
                        <div slot="label">Yes</div>
                    </tds-toggle>
                </div>
                <div  *ngIf="!employee.isReporting">
                    <tds-toggle size="lg" (change)="changeReportingStatus(employee)">
                        <div slot="label">No</div>
                    </tds-toggle>
                </div>
            </tds-body-cell>
        </tds-table-body-row>
        </tds-table-body>
        <tds-table-footer pages="{{totalPages}}" pagination></tds-table-footer>
    </tds-table>
</div>